import type { plus as Fr } from '../fr/plus';

/** « plus » in English — typed on the French: a missing sentence does not compile. */
export const plus: typeof Fr = {
  titre: 'Menu',
  seDeconnecter: 'Sign out',
};
